import Button from '@material-ui/core/Button'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { dateFromCalendar, formatDate } from '../../lib/formatDateHandler'
import * as actions from '../../store/actions'
import DataSporzadzeniaStyle from '../../styles/DataSporzadzeniaStyle'
import CustomDatePicker from '../controls/CustomDatePicker'

const DataSporzadzenia = ({
  onGetStructures,
  onSetDataSporzadzenia,
  onSetCzyWyborDaty,
  onUploadZipFile,
  paczkaZip,
  dataSporzadzenia,
}) => {
  const [data, setData] = useState(Date.now())

  useEffect(() => {
    if (dataSporzadzenia) setData(dataSporzadzenia)
  }, [])

  const zatwierdz = () => {
    const fData = formatDate(dateFromCalendar(data))
    onSetDataSporzadzenia(fData)
    onSetCzyWyborDaty(false)
    if (!paczkaZip) onGetStructures(fData)
    else onUploadZipFile(paczkaZip, fData)
  }

  return (
    <DataSporzadzeniaStyle>
      <div className="header">
        <span className="high-headline-5">DATA SPORZĄDZENIA SPRAWOZDANIA</span>
        <Button
          onClick={() => onSetCzyWyborDaty(false)}
          variant="outlined"
          color="primary"
        >
          WRÓĆ NA POCZĄTEK
        </Button>
      </div>
      <div className="window">
        <span className="medium-headline-5">
          Potwierdź lub zmień datę sporządzenia sprawozdania
        </span>
        <CustomDatePicker
          name="DataSporzadzenia"
          minDate={new Date(1995, 0, 1)}
          maxDate={new Date(2099, 11, 31)}
          label="Data sporządzenia"
          value={data}
          onChange={e => setData(e)}
        />
        <Button
          onClick={zatwierdz}
          variant="contained"
          color="primary"
          className="check"
          disabled={!data}
        >
          ZATWIERDŹ
        </Button>
      </div>
      <div className="footer">
        <span className="medium-headline-5">Dlaczego to takie ważne?</span>
        <p className="disabled-subtitle-2">
          Struktury logiczne używane do zapisu i elektronicznej wysyłki
          sprawozdań finasowych są okresowo zmieniane i mają już kilka wersji.
          To właśnie na podstawie daty sporządzenia decydujemy o tym, którego
          formatu należy użyć do zapisu Twojego sprawozdania.
        </p>
        <p className="disabled-subtitle-2">
          Prosimy, zastanów się nad wyborem tej daty. Po utworzeniu pliku XML z
          e-Sprawozdaniem jej późniejsza modyfikacja może być możliwa tylko w
          ograniczonym zakresie - takim, który nie spowoduje potrzeby zmiany
          formatu pliku.{' '}
        </p>
      </div>
    </DataSporzadzeniaStyle>
  )
}

const mapStateToProps = state => {
  return {
    paczkaZip: state.sprawozdanie.paczkaZip,
    dataSporzadzenia: state.sprawozdanie.dataSporzadzenia,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetDataSporzadzenia: data => dispatch(actions.setDataSporzadzenia(data)),
    onSetCzyWyborDaty: v => dispatch(actions.setCzyWyborDaty(v)),
    onGetStructures: data => dispatch(actions.getAvailableStructures(data)),
    onUploadZipFile: (paczka, data) =>
      dispatch(actions.uploadZipFile(paczka, data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataSporzadzenia)
